"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Color Schemes Module
 */
var EpsilonColorSchemes = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonColorSchemes(control) {
        this.control = control;
        this.context = this.control.container.find('.epsilon-color-scheme');
        if (!this.context.length) {
            return;
        }
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonColorSchemes.prototype.init = function () {
        var self = this;
        /**
         * Set variables
         */
        var options = this.context.find('.epsilon-color-scheme-option'), input = this.context.parent().find('[data-customize-setting-link]').first(), json = jQuery.parseJSON(options.first().find('input').val()), api = wp.customize, colorSettings = [], css = {
            action: 'epsilon_generate_color_scheme_css',
            class: 'Epsilon_Color_Scheme',
            id: '',
            data: {}
        };
        jQuery.each(json, function (index, value) {
            colorSettings.push(index);
        });
        _.each(colorSettings, function (setting) {
            css.data[setting] = api(setting)();
            if ('undefined' !== typeof api.control(setting)) {
                api.control(setting).container.on('change', 'input.epsilon-color-picker', _.debounce(function () {
                    self.context.siblings('.epsilon-color-scheme-selected').
                        find('.epsilon-color-scheme-palette').
                        find('*[data-field-id="' + setting + '"]').
                        css('background', jQuery(this).attr('value'));
                    css.data[setting] = api(setting)();
                    api.previewer.send('update-inline-color-schemes-css', css);
                }, 800));
            }
        });
        /**
         * On clicking a color scheme, update the color pickers
         */
        options.on('click', function () {
            var val = jQuery(this).attr('data-color-id'), json = jQuery(this).find('input').val();
            if (json) {
                json = jQuery.parseJSON(json);
            }
            /**
             * Find the customizer options
             */
            jQuery.each(json, function (index, value) {
                /**
                 * Set values
                 */
                jQuery('#customize-control-' + index + ' .epsilon-color-picker').minicolors('value', value);
                api(index).set(value);
                self.context.siblings('.epsilon-color-scheme-selected').find('.epsilon-color-scheme-palette').find('*[data-field-id="' + index + '"]').css('background', value);
            });
            /**
             * Remove the selected class from siblings
             */
            jQuery(this).siblings('.epsilon-color-scheme-option').removeClass('selected');
            /**
             * Make active the current selection
             */
            jQuery(this).addClass('selected');
            /**
             * Trigger change
             */
            input.val(val).trigger('change');
        });
        /**
         * Advanced toggler
         */
        jQuery('.epsilon-control-dropdown').on('click', function () {
            jQuery(this).toggleClass('active');
            jQuery(this).find('span').toggleClass('dashicons-arrow-down dashicons-arrow-up');
            self.context.slideToggle();
        });
    };
    return EpsilonColorSchemes;
}());
exports.EpsilonColorSchemes = EpsilonColorSchemes;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/color-schemes.ts
// module id = 38
// module chunks = 0